import React, { useCallback, useRef, useState } from "react";

import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";

import Alert from "react-bootstrap/Alert";
import { useSelector } from "react-redux";

import "../css/createTikTokDestination.css";
import {
    salesforceConnect,
    salesforceStore,
} from "../helpers/salesforce-lead/salesforce-lead";
import LoginButton from "./molecules/LoginButton";
import SwalAlertComp from "./SwalAlert";

const SalesForceLeadLogin = (props) => {
    const [isLoading, setIsLoading] = useState(false);
    const [sourceName, setSourceName] = useState();
    const [sourceHost, setSourceHost] = useState();
    const [isCreated, setIsCreated] = useState(false);

    const destinationId = useRef(null);
    const isAuthorizing = useRef(false);
    const language = useSelector((state) => state.languagesState.languages);

    const getAuthUrl = useCallback(async () => {
        if (
            sourceHost !== undefined &&
            sourceHost !== "" &&
            sourceName !== undefined &&
            sourceName !== ""
        ) {
            let response = await salesforceStore({
                name: sourceName,
                host: sourceHost,
            });
            if (response.status) {
                destinationId.current = response?.data?.service_id;
                isAuthorizing.current = false;

                return response?.data?.auth_url ?? null;
            } else {
                SwalAlertComp({
                    title: language?.delete_swal_modal?.failed ?? "Failed",
                    message: response.message,
                    icon: "error",
                });
            }
        } else {
            SwalAlertComp({
                title:
                    language?.destination_modal?.validation_error ??
                    "Validation Error!",
                message:
                    language?.destination_modal?.validation_error_msg ??
                    "Please fill in all fields.",
                icon: "error",
            });
        }
        return null;
    }, [language, props, sourceHost, sourceName]);

    const authorize = useCallback(
        async ({ code, state }) => {
            if (!destinationId.current || isAuthorizing.current) return;
            isAuthorizing.current = true;
            setIsLoading(true);
            const response = await salesforceConnect(destinationId.current, {
                code,
                state,
            });
            if (response.status) {
                setIsLoading(false);
                setIsCreated(true);
                props?.storeSuccess(response?.data?.destination_id);
                SwalAlertComp({
                    title: "Success",
                    message:
                        language?.destination_modal?.salesforce_success_msg ??
                        "SalesForce Connection Successful!",
                    icon: "success",
                });
            } else {
                setIsLoading(false);
                SwalAlertComp({
                    title: language?.delete_swal_modal?.failed ?? "Failed",
                    message: response.message,
                    icon: "error",
                });
            }
        },
        [language, props],
    );

    return (
        <div className="w-full">
            {!isCreated && (
                <div>
                    <FormControl className="mb-3" style={{ width: "100%" }}>
                        <TextField
                            name="name"
                            label={
                                language?.destination_modal?.source_name ??
                                "Source Name"
                            }
                            variant="outlined"
                            onChange={(e) => setSourceName(e.target.value)}
                            placeholder={
                                language?.destination_modal?.source_name ??
                                "Source Name"
                            }
                            value={sourceName}
                            error={sourceName === ""}
                            className="cloud-salesforce-name-input"
                        />
                    </FormControl>
                    <FormControl className="mb-3" style={{ width: "100%" }}>
                        <TextField
                            name="host"
                            label={language?.destination_modal?.host ?? "Host"}
                            variant="outlined"
                            onChange={(e) => setSourceHost(e.target.value)}
                            placeholder={
                                language?.destination_modal?.host ?? "Host"
                            }
                            value={sourceHost}
                            error={sourceHost === ""}
                            className="cloud-salesforce-host-input"
                        />
                    </FormControl>
                    <div className="position-relative overflow-hidden z-1">
                        <LoginButton
                            code="salesforce"
                            className="cloud-salesforce-create-button"
                            getAuthUrl={getAuthUrl}
                            paramNames={["code", "state"]}
                            requireAllParams
                            onSuccess={authorize}
                            onError={() => setIsLoading(false)}
                            onAuthUrlError={() => setIsLoading(false)}
                            logoSrc="/assets/images/ssalesforce.png"
                            logoWidth={55}
                            buttonText={
                                language?.destination_modal
                                    ?.create_with_salesforce ??
                                "Create with SalesForce"
                            }
                            isLoadingExternal={isLoading}
                        />
                    </div>
                </div>
            )}
        </div>
    );
};

export default SalesForceLeadLogin;
